import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { id: "about", label: "About" },
  { id: "aboutme", label: "About Me" },
  { id: "photography", label: "Photography" },
  { id: "video", label: "Video" },
  { id: "services", label: "Services" },
  { id: "contact", label: "Contact" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-[#F5F1EA]/90 backdrop-blur-md border-b border-[#1A1A1A]/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-5 flex items-center justify-between">
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="font-display text-[22px] tracking-tight leading-none"
        >
          Kenny Rodriguez<span className="italic-display text-[#8B6F47]">.</span>
        </button>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => scrollTo(l.id)}
              className="link-underline text-sm tracking-wide uppercase"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <button
          onClick={() => scrollTo("contact")}
          className="hidden md:inline-flex btn-primary rounded-full px-5 py-2.5 text-sm tracking-wide"
        >
          Book a Session
        </button>

        <button className="md:hidden" onClick={() => setOpen(!open)} aria-label="Menu">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#F5F1EA] border-t border-[#1A1A1A]/10">
          <div className="px-6 py-4 flex flex-col gap-4">
            {links.map((l) => (
              <button key={l.id} onClick={() => scrollTo(l.id)} className="text-left text-base">
                {l.label}
              </button>
            ))}
            <button onClick={() => scrollTo("contact")} className="btn-primary rounded-full px-5 py-2.5 text-sm w-fit">
              Book a Session
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
